import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { CustomerDetail } from "./CustomerDetail";

export const customerDetail = typeCheckAppModule({
    NAME,
    Container: CustomerDetail,
});
